import React from 'react';
import styled, { withTheme } from 'styled-components';
import { Screen } from '../components';

const splashLight = require('../assets/images/coinmend-splash-light.png');
const splashDark = require('../assets/images/coinmend-splash-dark.png');

const SplashLogo = styled.img`
  justify-content: center;
  width: 80%;
`;

const Splash = ({ theme }) => (
  <Screen theme={theme} title="Splash" centered>
    <SplashLogo src={theme.base === 'light' ? splashDark : splashLight} alt="" />
  </Screen>
);

export default withTheme(Splash);



// WEBPACK FOOTER //
// ./src/screens/Splash.js